import {Link} from 'react-router-dom';

function buildBeneficiaryDetailPath(backTo = '', adminScope = '', detailPath = '') {
    const searchParams = new URLSearchParams();

    if (adminScope) {
        searchParams.set('scope', adminScope);
    }

    if (backTo) {
        searchParams.set('returnTo', backTo);
    }

    const query = searchParams.toString();
    const basePath = detailPath || '/administrador/menu/caracterizacion/ver_beneficiarios';
    return `${basePath}${query ? `?${query}` : ''}`;
}

function BeneficiaryRow({beneficiary, backTo = '', adminScope = '', detailPath = ''}) {
    const isCopScope = adminScope === 'cop';
    const processCode =
        beneficiary?.school?.code ??
        beneficiary?.activityGroup?.activity?.name ??
        '-';
    const groupCode =
        beneficiary?.group?.code ??
        beneficiary?.activityGroup?.code ??
        '-';

    return (
        <div className='info-container'>
            <p className='school-option'>{beneficiary?.full_name}</p>
            <p className='school-option'>{beneficiary?.document}</p>
            <p className='school-option'>{processCode}</p>
            {!isCopScope && (
                <p className='school-option'>{groupCode}</p>
            )}
            <p className='school-option'>{beneficiary?.municipality?.name}</p>
            <p className='school-option'>{beneficiary?.neighborhood?.name}</p>

            <div className='school-option icons-container'>
                <Link
                    to={buildBeneficiaryDetailPath(backTo, adminScope, detailPath)}
                    state={backTo ? {...beneficiary, backTo} : beneficiary}
                    className='group'>
                    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 29.756 19.837'>
                        <path
                            id='Icon_awesome-eye'
                            data-name='Icon awesome-eye'
                            d='M29.576,13.664A16.569,16.569,0,0,0,14.878,4.5,16.572,16.572,0,0,0,.18,13.665a1.671,1.671,0,0,0,0,1.508,16.569,16.569,0,0,0,14.7,9.164,16.572,16.572,0,0,0,14.7-9.165A1.671,1.671,0,0,0,29.576,13.664Zm-14.7,8.193a7.439,7.439,0,1,1,7.439-7.439A7.439,7.439,0,0,1,14.878,21.858Zm0-12.4a4.924,4.924,0,0,0-1.308.2,2.472,2.472,0,0,1-3.456,3.456,4.948,4.948,0,1,0,4.764-3.652Z'
                            transform='translate(0 -4.5)'
                            fill='#00904C'
                        />
                    </svg>
                </Link>
            </div>
        </div>
    );
}

export default BeneficiaryRow;
